import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-20 md:pt-24 flex flex-col items-center justify-center min-h-[70vh] px-6 text-center">
        <h1 className="text-8xl md:text-[10rem] font-display font-black text-background-200 select-none">
          404
        </h1>
        <h2 className="text-xl md:text-2xl font-semibold text-foreground-900 mt-2 mb-3">
          页面未找到
        </h2>
        <p className="text-base text-foreground-500 max-w-md mb-8">
          您要查找的页面可能已被移除、名称已更改或暂时不可用。
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-6 py-2.5 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all duration-300"
        >
          <i className="ri-home-line"></i>
          返回首页
        </Link>
      </main>
      <Footer />
    </div>
  );
}